import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Button, Form, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import moment from 'moment';

function CargosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_CARGOS = import.meta.env.VITE_URL_CARGOS;
  const URL_USERS = import.meta.env.VITE_URL_USERS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  const [text, setText] = useState(false);
  const [users, setUsers] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [descripcion, setDescripcion] = useState("Cargo Mensual");
  const [importe, setImporte] = useState("");
  const [value, setValue] = useState('');
  const [validaBoton, setValidaBoton] = useState(true);

  const [saldoInicial, setSaldoInicial] = useState(0);
  const [saldoFinal, setSaldoFinal] = useState(0);
  const [abonos, setAbonos] = useState(0);
  const [retiros, setRetiros] = useState(0);
  const [utilidad, setUtilidad] = useState(0);
  const [porcentaje, setPorcentaje] = useState(20);

  useEffect(() => {
    axios.get(URL_USERS, {
      headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` }
    })
    .then(res => setUsers(res.data))
    .catch(err => console.log(err));
  }, []);

  // Función para calcular utilidad e importe automáticamente
  useEffect(() => {
    const calcUtilidad = (saldoFinal + retiros - abonos - saldoInicial);
    setUtilidad(calcUtilidad.toFixed(2));
    const calcImporte = calcUtilidad * (porcentaje / 100);
    setImporte(calcImporte.toFixed(2));
  }, [saldoFinal, retiros, abonos, saldoInicial, porcentaje]);

  const saveCargo = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios.post(URL_CARGOS, {
        fecha,
        descripcion,
        importe,
        user: value._id,
        abonos: 0,
        saldo: importe,
        saldoInicialUsuario: saldoInicial,
        abonosUsuario: abonos,
        retirosUsuario: retiros,
        utilidadUsuario: utilidad,
        saldoFinalUsuario: saldoFinal,
        porcentajeCargo: porcentaje
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` }
      });

      await axios.post(URL_LOGS, {
        tipo: 'Cargo',
        detalle: `${value._id}`,
        user: user.id
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` }
      });

      Swal.fire("¡Éxito!", "Cargo creado correctamente", "success");
      setTimeout(() => window.location.reload(), 1000);

    } catch (error) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Algo salió mal" });
      console.log(error);
      setValidaBoton(true);
    }
  };

  const options = users.map(option => {
    const firstLetter = option.nombre[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option, 
      junta: option.nombre
    };
  });

  return (
    <>
      <Header />
      <br />
      {user.usuarios_permisos && (
        <div className="card container">
          <h3 align="center">Crea un Cargo</h3>
          <Form onSubmit={saveCargo}>
            <Row>
              <Col md={4}>
                <Label>Usuario</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(event, selectedUser) => {
                    setValue(selectedUser);
                    setSaldoInicial(selectedUser?.ultimoSaldo || 0);
                    setAbonos(0)
                    setRetiros(0)
                    setUtilidad(0)
                    setSaldoFinal(0)
                    setPorcentaje(20)
                    setImporte(0)
                  }}
                  options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta}
                  renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                />
              </Col>
              <Col md={4}>
                <Label>Fecha</Label>
                <Input type="date" value={fecha} required onChange={(e) => setFecha(e.target.value)} />
              </Col>
              <Col md={4}>
                <Label>Descripción</Label>
                <Input type="text" value={descripcion} required onChange={(e) => setDescripcion(e.target.value)} />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Saldo Inicial</Label>
                <Input type="number" value={saldoInicial} onChange={(e) => setSaldoInicial(Number(e.target.value))} />
              </Col>
              <Col md={4}>
                <Label>Abonos</Label>
                <Input type="number" value={abonos} onChange={(e) => setAbonos(Number(e.target.value))} />
              </Col>
              <Col md={4}>
                <Label>Retiros</Label>
                <Input type="number" value={retiros} onChange={(e) => setRetiros(Number(e.target.value))} />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Saldo Final</Label>
                <Input type="number" value={saldoFinal} onChange={(e) => setSaldoFinal(Number(e.target.value))} />
              </Col>
              <Col md={4}>
                <Label>Utilidad</Label>
                <Input type="number" value={utilidad} disabled />
              </Col>
              <Col md={4}>
                <Label>Porcentaje</Label>
                <Input type="number" value={porcentaje} onChange={(e) => setPorcentaje(Number(e.target.value))} />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Importe</Label>
                <Input type="number" value={importe} disabled />
              </Col>
            </Row>
            <Row>
              {validaBoton ? (
                <Button type="submit" className="btn btn-success">Registrar</Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>Registrando...</Button>
              )}
              <Button href="/ListadoCargos" className="btn btn-danger">Regresar</Button>
            </Row>
          </Form>
        </div>
      )}
    </>
  );
}

export default CargosCreate;
